import { permutations } from "../permutations";

export const countPermutations = (number: string) => {
  const numArr = number.toString().split("");
  const result = permutations(numArr);
  return result.length;
};
